module.exports = __webpack_public_path__ + "src/images/products/trendsetter/115_Leopard Crewneck Sweater.png";